import { SoundPlayer } from "~/utils";

export enum AudioPaths {
  cardSlide = "cardPlace1.wav",
  chipLay = "chipLay3.wav",
  yourTurn = "pleasing-bell.wav",
}

export const soundPlayer = new SoundPlayer<AudioPaths>("/sound/");
